export type CardType = "plastic" | "virtual" | "other";

export interface ICardTypeContent {
  label: string;
  title: string;
  heading: string;
  copy: string;
  checks: string[];
}

// Контент по типу верификации карты (по ТЗ card_verification_strict_tz).
export const CARD_TYPES: Record<CardType, ICardTypeContent> = {
  plastic: {
    label: "Пластиковая карта",
    title: "Загрузите фото банковской карты",
    heading: "Как сделать фото",
    copy: "Загрузите фото вашей банковской карты на фоне открытой страницы сделки. Можно закрыть часть данных карты, но должны быть видны последние 4 цифры и имя держателя, если оно указано.",
    checks: [
      "банковскую карту",
      "ID сделки на фоне",
      "сумму и тип сделки на фоне",
      "последние 4 цифры карты",
    ],
  },
  virtual: {
    label: "Виртуальная карта",
    title: "Загрузите фото виртуальной карты",
    heading: "Как сделать фото или скрин",
    copy: "Откройте виртуальную карту в банковском приложении и сделайте фото или скрин на фоне открытой страницы сделки. Баланс и лишние данные можно закрыть.",
    checks: [
      "виртуальную карту на экране",
      "ID сделки на фоне",
      "сумму и тип сделки на фоне",
      "последние 4 цифры карты",
    ],
  },
  other: {
    label: "Другой способ",
    title: "Загрузите подтверждение карты",
    heading: "Дополнительный способ",
    copy: "Используйте этот вариант, если стандартная верификация не подходит. Загрузите подтверждение принадлежности карты на фоне открытой страницы сделки.",
    checks: [
      "подтверждение принадлежности карты",
      "ID сделки на фоне",
      "сумму и тип сделки на фоне",
      "без CVV, паролей и кодов",
    ],
  },
};

export const CARD_TYPE_ORDER: CardType[] = ["plastic", "virtual", "other"];
